import Icon from 'veui/components/Icon'
import { IconSearchDesktop } from 'dls-icons-vue'

Icon.register('search-desktop', IconSearchDesktop)
